export default __webpack_public_path__ + "static/media/logoExcel.b2ba46c2.png";